var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 29C22.8487 29 24.551 28.3729 25.9056 27.3199L26.5023 27.9165C26.4795 28.3277 26.6252 28.7465 26.9393 29.0607L33.9393 36.0607C34.5251 36.6464 35.4749 36.6464 36.0607 36.0607C36.6464 35.4749 36.6464 34.5251 36.0607 33.9393L29.0607 26.9393C28.7465 26.6252 28.3277 26.4795 27.9165 26.5023L27.3199 25.9056C28.3729 24.551 29 22.8487 29 21C29 16.5817 25.4183 13 21 13C16.5817 13 13 16.5817 13 21C13 25.4183 16.5817 29 21 29ZM21 27C24.3137 27 27 24.3137 27 21C27 17.6863 24.3137 15 21 15C17.6863 15 15 17.6863 15 21C15 24.3137 17.6863 27 21 27Z",
    fill: "#929292"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/Search_icon.780e5e59fa939554297e64e235979d71.svg";
export { ForwardRef as ReactComponent };